
import { Injectable } from '@angular/core';
import {
    ApplicationInfoDto,
    GetCurrentLoginInformationsOutput,
    SessionServiceProxy,
    TenantLoginInfoDto,
    UserLoginInfoDto,
    FarmerDto
} from '@shared/service-proxies/service-proxies';
import { AppStorageService } from '@shared/storage/app-storage.service';
import { MultiTenancyService } from '@shared/multi-tenancy/mult-tenancy.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class AppSessionService {

    private _user: UserLoginInfoDto;
    private _tenant: TenantLoginInfoDto;
    private _application: ApplicationInfoDto;
    private _farmer: FarmerDto

    constructor(
        private _sessionService: SessionServiceProxy,
        private _multiTenancyService: MultiTenancyService,
        private storageService: AppStorageService) {
        this.storageService.UserSubject.pipe(tap(_ => console.debug("UserSubject-AppSessionService-776130f1-af7a-4f36-a4b3-f1a86676c2d6"))).subscribe(u => this._user = u);
    }

    get application(): ApplicationInfoDto {
        return this._application;
    }
    
    get farmer(): FarmerDto {
        return this._farmer;
    }

    get farmerId(): number {
        return this.farmer ? this.farmer.id : null;
    }

    get user(): UserLoginInfoDto {
        return this._user;
    }

    get userId(): number {
        return this.user ? this.user.id : null;
    }

    get tenant(): TenantLoginInfoDto {
        return this._tenant;
    }

    get tenantId(): number {
        return this.tenant ? this.tenant.id : null;
    }

    getShownLoginName(): string {
        const userName = this._user.userName;
        if (!this._multiTenancyService.isEnabled) {
            return userName;
        }

        return (this._tenant ? this._tenant.tenancyName : '.') + '\\' + userName;
    }

    init(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this._sessionService.getCurrentLoginInformations().toPromise().then((result: GetCurrentLoginInformationsOutput) => {
                this._application = result.application;
                this._user = result.user;
                this._tenant = result.tenant;
                this._farmer = result.farmer;
                this.storageService.setUser(this._user);
                resolve(true);
            }, (err) => {
                reject(err);
            });
        });
    }

    changeTenantIfNeeded(tenantId?: number): boolean {
        if (this.isCurrentTenant(tenantId)) {
            return false;
        }
        this.storageService.setTenantId(tenantId);

        location.reload();
        return true;
    }

    private isCurrentTenant(tenantId?: number) {
        if (!tenantId && this.tenant) {
            return false;
        } else if (tenantId && (!this.tenant || this.tenant.id !== tenantId)) {
            return false;
        }

        return true;
    }
}
